module.exports = __webpack_public_path__ + "img/cardskill.7e152356.svg";